import React from "react";

import clients from "../../assets/images/recruiter/clients.svg";
import clientsactive from "../../assets/images/recruiter/clientsactive.svg";
import job from "../../assets/images/recruiter/job.svg";
import jobactive from "../../assets/images/recruiter/jobactive.svg";
import members from "../../assets/images/recruiter/members.svg";
import membersactive from "../../assets/images/recruiter/membersactive.svg";
import sorting from "../../assets/images/recruiter/clients/sorting.svg";
import filter from "../../assets/images/recruiter/clients/filter.svg";
import search from "../../assets/images/recruiter/clients/icon-search.svg";
import newclient from "../../assets/images/recruiter/clients/new-client.svg";
import location from "../../assets/images/recruiter/location.svg";
import phone from "../../assets/images/recruiter/phone.svg";
import email from "../../assets/images/recruiter/email.svg";
import prof from "../../assets/images/prof.svg";
import notepad from "../../assets/images/notepad.svg";
import pause from "../../assets/images/pause.svg";

// sample company logo
import companylogo1 from "../../assets/images/recruiter/clients/at-and-t.png";
import companylogo2 from "../../assets/images/recruiter/clients/zyxel.svg.png";
import companylogo3 from "../../assets/images/recruiter/clients/huawei.png";
import burger_king from "../../assets/images/recruiter/clients/burger_king.png";

const icons = {
  clients: clients,
  clientsactive: clientsactive,
  job: job,
  jobactive: jobactive,
  members: members,
  membersactive: membersactive,
  sorting: sorting,
  filter: filter,
  search: search,
  newclient: newclient,
  company: [companylogo1, companylogo2, companylogo3],
  burger_king,
  location,
  phone,
  email,
  prof,
  notepad,
  pause
};

export const UseIcon = ({ icon, title, simg, stext }) => (
  <span>
    <img className={simg} src={icons[icon]} alt={title} />
    <span className={stext}>{title}</span>
  </span>
);
